import { deletee, get, post, put } from '.';
import { IRegion } from '../types';
import { AxiosPromise } from 'axios';

export type IGetbrandRes = IRegion[];
export const getPatternService = (): AxiosPromise<IGetbrandRes> => {
  return get({
    subUrl: '/pattern/admin/pattern-types'
  });
};

export type IAddPatternData = {
  name: string;
};
export const createPatternService = (
  data: IAddPatternData
): AxiosPromise<IRegion> => {
  return post({
    subUrl: '/pattern/admin/pattern-types',
    data: data
  });
};

export const deletePatternService = (id: string) => {
  return deletee({
    subUrl: '/pattern/admin/pattern-types',
    params: { id }
  });
};

export type IEditPatternData = {
  id: string;
  name: string;
};
export const updatePatternSerive = (data: IEditPatternData) => {
  return put({
    subUrl: '/pattern/admin/pattern-types',
    data
  });
};
